import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Topics from './components/Topics';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Comments from './components/Comments';
import Contact from './components/Contact';
import App from './components/App';
import Updates from './components/Updates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <FAQ />
        <Media />
        <Carousel />
        <Cards />
        <Topics />
        <Features />
        <Ranking />
        <Index />
        <Comments />
        <Contact />
        <App />
        <Updates />
      </main>
      <Footer />
    </>
  );
}